export default __webpack_public_path__ + "static/media/error.d8c74b37.svg";